<template>
  <div style="width: 100%; height: 100%">
    <!--工具栏-->
    <div class="kl_video_header" v-if="showToolBar">
      <div class="layout_box" :class="myLayout == 'box1' ? 'layout_box1_active' : 'layout_box1'"
        @click="myLayout = 'box1'"></div>
      <div class="layout_box" :class="myLayout == 'box4' ? 'layout_box4_active' : 'layout_box4'"
        @click="myLayout = 'box4'"></div>
      <div class="layout_box" :class="myLayout == 'box6' ? 'layout_box6_active' : 'layout_box6'"
        @click="myLayout = 'box6'"></div>

      <div class="layout_box" :class="myLayout == 'box9' ? 'layout_box9_active' : 'layout_box9'"
        @click="myLayout = 'box9'"></div>

      <div class="layout_box" :class="myLayout == 'box16' ? 'layout_box16_active' : 'layout_box16'"
        @click="myLayout = 'box16'"></div>

      <!--布局切换，一个select下拉，一个按钮，用elementui-->
      <el-select v-model="myLayout" :placeholder="$t('videom.窗口数量')" style="width: 80px; margin-right: 16px"
        size="small">
        <el-option label="1" value="box1"></el-option>
        <el-option label="4" value="box4"></el-option>
        <el-option label="6" value="box6"></el-option>
        <el-option label="9" value="box9"></el-option>
        <el-option label="10" value="box10"></el-option>
        <el-option label="16" value="box16"></el-option>
        <el-option label="25" value="box25"></el-option>
        <el-option label="36" value="box36"></el-option>
        <el-option label="48" value="box48"></el-option>
        <el-option label="64" value="box64"></el-option>
        <el-option label="100" value="box100"></el-option>
      </el-select>
      <!--全部暂停-->
      <div v-if="false" class="layout_box layout_all_pause" :title="$t('videom.全部暂停')"></div>
      <div v-if="false" class="layout_box layout_all_play" :title="$t('videom.全部继续')"></div>
      <!--全部停止-->
      <div class="layout_box layout_all_stop" @click="closeAllWnd" :title="$t('videom.全部停止')"></div>
      <!--全屏-->
      <div class="layout_box layout_full_screen" @click="fullScreen" :title="$t('videom.全屏')"></div>
      <template v-if="false">
        <el-select v-model="deviceNo" :placeholder="$t('videom.请选择设备')" style="width: 160px">
          <el-option v-for="item in deviceList" :key="item.DeviceNo" :label="item.DeviceNo"
            :value="item.DeviceNo"></el-option>
        </el-select>
        <!-- <el-input
          size="small"
          v-model="deviceNo"
          style="width: 160px"
        ></el-input> -->
        <el-input size="small" v-model="channel" style="width: 60px"></el-input>
        <el-input size="small" v-if="false" v-model="serverip" style="width: 160px"></el-input>
        <el-button style="margin-right: 16px" size="small" type="primary" @click="startPlay">{{ $t("videom.开启播放")
          }}</el-button>
      </template>
    </div>
    <MPlayBase :boxId="boxId" ref="mplaybase" :playMode="playMode"
      :style="{ height: showToolBar ? 'calc(100% - 60px)' : '100%' }" />
  </div>
</template>
<script>
import MPlayBase from "./MPlayBase";
import { queryVideoDeviceNoByTime } from "@/http/vehicle";
import settings from "@/settings";
export default {
  components: {
    MPlayBase,
  },
  props: {
    showToolBar: {
      type: Boolean,
      default: true,
    },
    numCount: {
      type: String,
      default: "box4",
    },
    playMode: {
      type: String,
      default: "real", //history or real 历史或者实时
    },
  },
  data() {
    return {
      boxId: "box22",
      myLayout: "box4",
      deviceNo: "004010009175",
      deviceList: [],
      serverip: "106.12.137.238",//"182.61.34.145",// //自建的服务器
      tcpport: 1078, // 回放的端口不一样 10781
      replay_tcpport: 10781, // 回放的端口不一样 10781
      udpport: 0, //
      channel: 1, //
      isSelfServer: true, //是否自建服务器
      isTest: false,
    };
  },

  watch: {
    myLayout() {
      this.layoutChange();
    },
    playMode: {
      handler() {
        console.log("playMode change");
        console.log(this.playMode);
        if (this.playMode == "history") {
          this.myLayout = "box1";
        }
      },
      immediate: true,
    },

    // numCount(){
    //   // console.log('layout change');
    //   // console.log(this.numCount);
    //   // this.myLayout = this.numCount;

    // }
  },
  created() {
    //监听websocket事件
    if (this.playMode == "real") {
      this.socketClient.AttachEvent(
        "RealTimeMultiMediaDeviceTransfer",
        this.socketClient.eventType.onRealTimeMultiMediaDeviceTransferAck,
        this.RealTimeMultiMediaDeviceTransferAck
      );
    }
    if (this.playMode == "history") {
      this.socketClient.AttachEvent(
        "RemoteVideoReplayAck",
        this.socketClient.eventType.onRemoteVideoReplayAck,
        this.RealTimeMultiMediaDeviceTransferAck
      );
    }
  },
  beforeDestroy() {
    var list = this.$refs.mplaybase.GetAllWnd();
    list.forEach((element) => {
      this.YXShutDown(element);
    });
    //实时视频控制
    if (this.playMode == "real") {
      this.socketClient.DetachEvent(
        "RealTimeMultiMediaDeviceTransfer",
        this.socketClient.eventType.onRealTimeMultiMediaDeviceTransferAck
      );
    }
    if (this.playMode == "history") {
      //历史视频控制
      this.socketClient.DetachEvent(
        "RemoteVideoReplayControlAck",
        this.socketClient.eventType.onRemoteVideoReplayControlAck
      );
    }
  },
  methods: {
    DeviceResponseResult(v_params) {
      var resultMsg = "";
      var szResult = v_params.result;
      switch (szResult) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }
      return resultMsg;
    },
    YXShutDown(videoPlayer, resultMsg) {
      videoPlayer.setPromptWord(resultMsg);
      if (this.isSelfServer) {
        videoPlayer.stop();
        //要不要统一逻辑，没有人看的时候，关闭设备上报
      } else {
        if (
          videoPlayer.sessionid != null &&
          videoPlayer.sessionid != undefined &&
          videoPlayer.sessionid != ""
        ) {
          this.$api
            .videoStreamControl({
              act: "Shutdown",
              sessionid: videoPlayer.sessionid,
              channelid: videoPlayer.iChannelId,
            })
            .then((res) => {
              if (res.keepalive != undefined && res.keepalive < 1) {
                //通知
                //当前正在进行的是哪种播放
                if (videoPlayer != null) {
                  if (videoPlayer.isRealPlay == 0) {
                    //    console.log('关闭实时监控');
                    this.socketClient.socket.MultiMediaDeviceRealTimeTransferControl(
                      videoPlayer.simNum,
                      videoPlayer.iChannelId,
                      0,
                      0,
                      0
                    );
                  } else {
                    //  console.log('关闭视频回放');
                    this.socketClient.socket.RemoteVideoReplayControl(
                      // this.yx_mobile,
                      videoPlayer.simNum,
                      videoPlayer.iChannelId,
                      2,
                      0,
                      "0000-00-00 00:00:00"
                    );
                  }
                }
              }

              videoPlayer.stop();
            });
        } else {
          videoPlayer.stop();
        }
      }
    },
    RealTimeMultiMediaDeviceTransferAck(v_params) {
      //终端有应答了

      var resultMsg = this.DeviceResponseResult(v_params);
      // console.log(resultMsg);
      var _uiChannel = 0;
      if (
        v_params.request &&
        (v_params.request.Method === "RealTimeMultiMediaDeviceTransferReq" ||
          v_params.request.Method === "RemoteVideoReplayReq")
      ) {
        //解析出请求的参数，停止单个端口的播放请求
        var request_params = JSON.parse(v_params.request.params);
        _uiChannel = request_params._uiChannel;
      }

      var players = [];
      if (_uiChannel != 0) {
        players = this.$refs.mplaybase.GetWndBySimChannel(
          v_params.mobile,
          _uiChannel
        );
        console.log("寻找到的");
        console.log(players);
      }
      console.log("请求的", resultMsg);

      if (resultMsg != "") {
        //发生错误,关闭这个设备的所有通道，停止播放
        if (players.length != 0) {
          players.forEach((element) => {
            //停止播放
            this.YXShutDown(element, resultMsg);
          });
        } else {
          players = this.$refs.mplaybase.GetWndBySimNum(v_params.mobile);
          players.forEach((element) => {
            //停止播放
            this.YXShutDown(element, resultMsg);
          });
        }
        return;
      } else {

        if (players.length != 0) {
          players.forEach((element) => {
            //链接成功
            element.setPromptWord("connSuccess");
          });
        }
      }
    },
    //停止某台车的播放
    CloseVideoBySimNum(simNum) {
      var players = this.$refs.mplaybase.GetWndBySimNum(simNum);
      players.forEach((element) => {
        //停止播放
        this.YXShutDown(element, this.$t("videom.停止播放"));
      });
    },
    StartHistoryVideo(simNum, channelId, plateNum, startTime, endTime) {
      console.log("StartHistoryVideo");
      this.$refs.mplaybase.SetWait(simNum, channelId, plateNum);
      //是否测试
      if (this.isTest) {
        this.$refs.mplaybase.ConfirmConn(
          simNum,
          channelId,
          0,
          this.serverip,
          this.replay_tcpport,
          1
        );
      } else {
        this.requestVideoConfig(simNum, channelId, startTime, endTime);
      }
    },
    SetHistoryPlaybackRate(simNum, channelId, rate) {
        // 下发快进指令到设备端
        this.socketClient.socket.RemoteVideoReplayControl(
                  simNum,
                 channelId,
                  3,
                 rate,
                 ""
                );
        // 同时调整本地播放器倍速，使缓冲区消耗与下发速率同步
        this.$refs.mplaybase.SetPlaybackRate(simNum, channelId, rate);
    },
    SetWait(simNum, channelId, plateNum) {
      console.log(Date.now())
      settings.routeStartTime[simNum] = Date.now()
      console.log(simNum, channelId, plateNum);
      this.$refs.mplaybase.SetWait(simNum, channelId, plateNum);

      //是否测试
      if (this.isTest) {
        this.$refs.mplaybase.ConfirmConn(
          simNum,
          channelId,
          0,
          this.serverip,
          this.tcpport,
          0
        );
      } else {
        this.requestVideoConfig(simNum, channelId);
      }
    },
    requestVideoConfig(simNum, channelId, startTime, endTime) {
      //自建的服务器不需要这个步骤
      if (this.isSelfServer) {
        this.$refs.mplaybase.ConfirmConn(
          simNum,
          channelId,
          0,
          this.serverip,
          this.playMode == 'real' ? this.tcpport : this.replay_tcpport,
          this.playMode == "real" ? 0 : 1
        );
        //下发webcoket
        if (this.playMode == "real") {
          this.socketClient.socket.RealTimeMultiMediaDeviceTransferReq(
            simNum,
            this.serverip,
            this.tcpport,
            0,
            channelId,
            0,
            1
          );
        }
        if (this.playMode == "history") {
          this.socketClient.socket.RemoteVideoReplayReq(
            simNum,
            this.serverip,
            this.replay_tcpport,
            0,
            channelId,
            0,
            0,
            0,
            0,
            0,
            startTime,
            endTime
          );
        }
      } else {
        this.$api
          .videoStreamControl({
            act: "Startup",
            vehicleid: simNum,
            vehicleno: simNum,
            channelid: channelId,
            type: this.playMode == "real" ? 0 : 1, //实时还是历史 0是实时播放
            duration: "",
            nettype: 1,
          })
          .then((res) => {
            if (res.status == 0 || res.status == "0") {
              this.$refs.mplaybase.ConfirmConn(
                simNum,
                channelId,
                res.sessionid,
                res.serverip,
                res.tcpport,
                res.type
              );
              if (this.playMode == "real") {
                //下发webcoket
                this.socketClient.socket.RealTimeMultiMediaDeviceTransferReq(
                  simNum,
                  res.serverip,
                  res.tcpport,
                  res.udpport,
                  channelId,
                  0,
                  1
                );
              }

              if (this.playMode == "history") {
                this.socketClient.socket.RemoteVideoReplayReq(
                  simNum,
                  res.serverip,
                  res.tcpport,
                  res.udpport,
                  channelId,
                  0,
                  0,
                  0,
                  0,
                  0,
                  startTime,
                  endTime
                );
              }
            } else {
              var res_str = "";
              switch (res.status) {
                case 102:
                  res_str = this.$t("videom.usernameerror");
                  break;
                case 103:
                  res_str = this.$t("videom.pswerror");
                  break;
                case 104:
                  res_str = this.$t("videom.accouterror");
                  break;
                case 201:
                  res_str = this.$t("videom.urlerror");
                  break;
                case 202:
                  res_str = this.$t("videom.servicenosupport");
                  break;
                case 203:
                  res_str = this.$t("videom.parmempty");
                  break;
                case 204:
                  res_str = this.$t("videom.parmerror");
                  break;
                case 401:
                  res_str = this.$t("videom.systemtimeout");
                  break;
                case 410:
                  res_str = this.$t("videom.devicenowinrealplay");
                  break;
                case 411:
                  res_str = this.$t("videom.devicenowinplay");
                  break;
                default:
                  res_str = this.$t("videom.exceptionoccurred") + res.status;
                  break;
              }
              //提示发生错误
              this.$refs.mplaybase.SetWndPromptWord(simNum, channelId, res_str);
            }
          });
      }
    },
    startPlay() {
      //需要先找到未使用的index
      //随机生成一个数字，长度为12
      let deviceNo = this.deviceNo; // Math.floor(Math.random() * 1000000000000);
      //随机生成一个车牌号
      // let plate = "闽d12" + Math.floor(Math.random() * 1000);
      // //随机生成一个通道号 , 0-9
      // let channel = Math.floor(Math.random() * 10);
      //10个通过一起看

      // this.playerProperties[0].setWait(deviceNo, channel, plate);
      // this.playerProperties[0].confirmConn();
      // for (var i = 0; i < 5; i++) {
      //   var channel = i + 1;
      //   this.$refs.mplaybase.SetWait(deviceNo, channel, deviceNo);
      //   this.$refs.mplaybase.ConfirmConn(deviceNo, channel);
      // }
      console.log("asdf");
      var ic = parseInt(this.channel);

      this.SetWait(deviceNo, ic, deviceNo);

      this.$refs.mplaybase.ConfirmConn(deviceNo, ic, deviceNo);

      //给外部用的 调用 SetWait confirmConn
    },
    closeAllWnd() {
      this.$refs.mplaybase.CloseAllWnd();
    },
    fullScreen() {
      this.$refs.mplaybase.FullWndScreen();
    },
    layoutChange() {
      console.log(this.myLayout);
      let num = 4;
      num = parseInt(this.myLayout.replace("box", ""));
      this.$refs.mplaybase.SetWindowsNum(num);
    },
  },
  mounted() {
    // this.layoutChange();
    queryVideoDeviceNoByTime({
    }).then((res) => {

      this.deviceList = res.data;

    });
  },
};
</script>
<style scoped>
.kl_video_header {
  background-color: #d8d8d800;
  border: 1px solid #979797;
  height: 60px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: flex-end;
}

.layout_box {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: 16px;
}

.layout_box1 {
  background-image: url("@/assets/images/box1.png");
}

.layout_box1:hover,
.layout_box1_active {
  background-image: url("@/assets/images/box1_active.png");
}

.layout_box4 {
  background-image: url("@/assets/images/box4.png");
}

.layout_box4:hover,
.layout_box4_active {
  background-image: url("@/assets/images/box4_active.png");
}

.layout_box6 {
  background-image: url("@/assets/images/box6.png");
}

.layout_box6:hover,
.layout_box6_active {
  background-image: url("@/assets/images/box6_active.png");
}

.layout_box9 {
  background-image: url("@/assets/images/box9.png");
}

.layout_box9:hover,
.layout_box9_active {
  background-image: url("@/assets/images/box9_active.png");
}

.layout_box16 {
  background-image: url("@/assets/images/box16.png");
}

.layout_box16:hover,
.layout_box16_active {
  background-image: url("@/assets/images/box16_active.png");
}

.layout_all_play {
  background-image: url("@/assets/images/ic_play.png");
}

.layout_all_pause {
  background-image: url("@/assets/images/ic_pause.png");
}

.layout_all_stop {
  background-image: url("@/assets/images/ic_stop.png");
}

.layout_full_screen {
  background-image: url("@/assets/images/ic_full_screen.png");
}
</style>
